import * as React from 'react';

import config from 'js/app/config';

import { Button, Grid, TextField } from '@coursera/cds-core';
import { CheckIcon, LinkIcon, WarningFilledIcon } from '@coursera/cds-icons';

import _t from 'i18n!nls/enterprise-admin-program-creation';

export const CopyProgramLink = ({
  programSlug,
  link,
  onCopy,
  inputLabel,
  buttonVariant = 'primary',
}: {
  programSlug?: string;
  /** Overrides the default `/programs/{programSlug}` URL — e.g. the System Program's shareable
   * link is org home, not a program page. */
  link?: string;
  onCopy: $TSFixMe;
  inputLabel: string;
  buttonVariant?: 'primary' | 'secondary';
}) => {
  const [status, setStatus] = React.useState<'initial' | 'copied' | 'failed'>('initial');
  const value = link ?? `${config.url.base}programs/${programSlug}`;
  let icon: JSX.Element;
  let label: string;
  if (status === 'initial') {
    icon = <LinkIcon />;
    label = _t('Copy link');
  } else if (status === 'failed') {
    icon = <WarningFilledIcon />;
    label = _t('Failed!');
  } else {
    icon = <CheckIcon />;
    label = _t('Link copied!');
  }
  const resetStatus = () => {
    setTimeout(() => {
      setStatus('initial');
    }, 2000);
  };

  return (
    <Grid container spacing={16} alignItems="flex-end">
      <Grid item sm>
        <TextField fullWidth label={inputLabel} value={value} onFocus={(event) => event.target.select()} />
      </Grid>
      <Grid item>
        <Button
          variant={buttonVariant}
          icon={icon}
          iconPosition="before"
          onClick={async () => {
            try {
              await onCopy(value);
              setStatus('copied');
              resetStatus();
            } catch {
              setStatus('failed');
            }
          }}
          data-e2e="copy"
        >
          {label}
        </Button>
      </Grid>
    </Grid>
  );
};
